import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { GrdfConsentService } from '../grdf-consent.service';

import { GrdfAccessRightStatus } from '../../../grdf.models';

@Component({
    selector: 'app-grdf-consent-revoked',
    templateUrl: './grdf-consent-revoked.component.html',
    styleUrls: ['./grdf-consent-revoked.component.scss'],
})
export class GrdfConsentRevokedComponent {
    token: string | null = null;
    error: boolean = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private grdfConsentService: GrdfConsentService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            this.token = params['token'];

            if (!this.token) {
                this.error = true;
                console.error('Token is missing');
                return;
            }

            try {
                await this.grdfConsentService.updateConsent(
                    this.token,
                    GrdfAccessRightStatus.REVOKED,
                );
            } catch (err: any) {
                console.error('Error revoking consent', err);
                this.error = true;
            }
        });
    }
}
